<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  <pdq-tab label="Settings" value="settings" [active]="activeTab === 'settings'"></pdq-tab>
  <pdq-tab label="Goals" value="goals" [active]="activeTab === 'goals'"></pdq-tab>
  <pdq-tab label="Timer" value="timer" [active]="activeTab === 'timer'"></pdq-tab>
  <pdq-tab
    label="Display Conditions"
    value="display-conditions"
    [active]="activeTab === 'display-conditions'"></pdq-tab>
</pdq-tabs-group>

@switch (activeTab) {
  @case ('settings') {
    <smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>
    <smart-cart-goals-settings-tab [formGroup]="formGroup"></smart-cart-goals-settings-tab>
  }
  @case ('goals') {
    <smart-cart-goals-tab
      [formGroup]="formGroup"
      [globalSettingsFormGroup]="globalSettingsFormGroup"
      [smartCartId]="smartCartId"
      [usageToken]="usageToken"></smart-cart-goals-tab>
  }
  @case ('timer') {
    <smart-cart-goals-timer-tab
      [formGroup]="formGroup"
      [smartCartId]="smartCartId"
      [usageToken]="usageToken"></smart-cart-goals-timer-tab>
  }
  @case ('display-conditions') {
    @if (displayConditionsGroup; as displayConditionsForm) {
      <smart-cart-form-display-conditions [formGroup]="displayConditionsForm"></smart-cart-form-display-conditions>
    }
  }
}
